import React from 'react'
import { array } from 'prop-types'
import { navigate } from 'gatsby'
import Select, { components } from 'react-select'

import { DROPDOWN_STYLES } from '../../util/constants'
import * as Styled from './styles/TableOfContentsDropdown.styles'

const EllipsisVertical = () => (
  <svg
    width="6"
    height="24"
    viewBox="0 0 6 24"
    fill="#101F73"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="3" cy="3" r="3" />
    <circle cx="3" cy="12" r="3" />
    <circle cx="3" cy="21" r="3" />
  </svg>
)

const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <EllipsisVertical />
  </components.DropdownIndicator>
)

const TableOfContentsDropdown = ({ filteredOptions }) => {
  if (!filteredOptions || filteredOptions.length <= 1) {
    return null
  }

  return (
    <Styled.TableOfContentsDropdown>
      <Select
        components={{ DropdownIndicator }}
        styles={DROPDOWN_STYLES}
        placeholder="Table of Contents"
        // menuIsOpen={true}
        options={filteredOptions}
        onChange={e => {
          navigate(`/${e.value}/`)
        }}
      />
    </Styled.TableOfContentsDropdown>
  )
}

TableOfContentsDropdown.propTypes = {
  filteredOptions: array,
}

export default TableOfContentsDropdown
